import React from 'react';
import {
  Box,
  Button,
  MenuItem,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { http } from '../api/http';
import { PageHeader } from '../components/PageHeader';
import { ErrorBanner } from '../components/ErrorBanner';
import { useAppUi } from '../app/useAppUi';

export function BroadcastPage() {
  const { t } = useAppUi();
  const [text, setText] = React.useState('');
  const [botLang, setBotLang] = React.useState('all');
  const [file, setFile] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [result, setResult] = React.useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const form = new FormData();
      form.append('text', text);
      if (botLang) form.append('bot_lang', botLang);
      if (file) form.append('file', file);

      const res = await http.post('/admin/send-message', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setResult(res?.data);
      setText('');
      setFile(null);
    } catch (e2) {
      setError(e2);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <PageHeader title={t('broadcast.title')} subtitle={t('broadcast.subtitle')} />
      <ErrorBanner error={error} />

      <Paper
        elevation={0}
        sx={{
          p: 3,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1.5,
          maxWidth: 900,
        }}
      >
        <Box component="form" onSubmit={onSubmit}>
          <Stack spacing={2}>
            <TextField
              label={t('broadcast.messageLabel')}
              value={text}
              onChange={(e) => setText(e.target.value)}
              multiline
              minRows={5}
              required
            />
            <TextField
              select
              label={t('broadcast.targetLang')}
              value={botLang}
              onChange={(e) => setBotLang(e.target.value)}
              sx={{ width: 280 }}
            >
              <MenuItem value="all">{t('botLang.all')}</MenuItem>
              <MenuItem value="uz">{t('botLang.uz')}</MenuItem>
              <MenuItem value="ru">{t('botLang.ru')}</MenuItem>
              <MenuItem value="en">{t('botLang.en')}</MenuItem>
            </TextField>
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems={{ md: 'center' }}>
              <Button variant="outlined" component="label">
                {t('broadcast.attach')}
                <input
                  type="file"
                  hidden
                  accept="image/*,video/*"
                  onChange={(e) => setFile(e.target.files?.[0] || null)}
                />
              </Button>
              <Typography variant="body2" color="text.secondary">
                {file ? t('broadcast.selectedFile', { name: file.name }) : t('broadcast.optionalMedia')}
              </Typography>
            </Stack>
            <Button type="submit" variant="contained" disabled={loading}>
              {loading ? t('common.queueing') : t('broadcast.queue')}
            </Button>
            {result ? (
              <Typography variant="body2" color="text.secondary">
                {t('common.result')}: {JSON.stringify(result)}
              </Typography>
            ) : null}
          </Stack>
        </Box>
      </Paper>
    </Box>
  );
}

